import Vue from "vue";

Vue.directive("open-mobile-navigation",
    {
        bind(el)
        {
            el.onclick = () => {
                // Schließe Suche wenn Navigation geöffnet wird
                document.querySelector(".searchwrapper")?.classList.remove("open");
                ceresStore.commit("setIsMobileNavigationOpen", true);
            };
        }
    });
